// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Leaderboard.css */

.leaderboard {
  font-family: "Arial", sans-serif;
  max-width: 50vmin;
  max-height: 50vmin;
  margin: 2rem auto;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  min-width: 80vmin;
  overflow-y: scroll;
}

.leaderboard h1 {
  color: #f5f1f1;
  margin-bottom: 1rem;
}

ul {
  list-style-type: none;
  padding: 0;
}

.player {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  margin: 0.5rem 0;
  background-color: #fff;
  border-radius: 8px;
  transition: background-color 0.3s;
}

.player:hover {
  background-color: #e0e0e0;
}

.rank,
.name,
.score {
  flex: 1 1;
  text-align: center;
}

.rank {
  color: #ff4500;
}

.score {
  color: rgb(203, 9, 9);
}

@keyframes bounce {

  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-20px);
  }

  60% {
    transform: translateY(-10px);
  }
}

.leaderboard h1 {
  animation: bounce 2s infinite;
}

/* Leaderboard.css (añadir al final del archivo) */

.trophy {
  font-size: 1.5rem;
  margin-right: 0.5rem;
  flex: 1 1;
  text-align: center;
}

.gold {
  color: gold;
}

.silver {
  color: silver;
}

.bronze {
  color: #cd7f32;
}


@keyframes fireworks {
  0% {
    opacity: 1;
    transform: scale(0.5);
  }

  100% {
    opacity: 0;
    transform: scale(1);
  }
}

.firework {
  position: absolute;
  background: radial-gradient(circle, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 70%);
  border-radius: 50%;
  opacity: 0;
  width: 10px;
  height: 10px;
  animation: fireworks 1s ease-out infinite;
}`, "",{"version":3,"sources":["webpack://./src/components/leaderboard/leaderboard.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kDAAkD;;AAElD;EACE,iBAAiB;EACjB,oBAAoB;EACpB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,0FAA0F;EAC1F,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yCAAyC;AAC3C","sourcesContent":["/* Leaderboard.css */\n\n.leaderboard {\n  font-family: \"Arial\", sans-serif;\n  max-width: 50vmin;\n  max-height: 50vmin;\n  margin: 2rem auto;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  min-width: 80vmin;\n  overflow-y: scroll;\n}\n\n.leaderboard h1 {\n  color: #f5f1f1;\n  margin-bottom: 1rem;\n}\n\nul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.player {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem;\n  margin: 0.5rem 0;\n  background-color: #fff;\n  border-radius: 8px;\n  transition: background-color 0.3s;\n}\n\n.player:hover {\n  background-color: #e0e0e0;\n}\n\n.rank,\n.name,\n.score {\n  flex: 1;\n  text-align: center;\n}\n\n.rank {\n  color: #ff4500;\n}\n\n.score {\n  color: rgb(203, 9, 9);\n}\n\n@keyframes bounce {\n\n  0%,\n  20%,\n  50%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n\n  40% {\n    transform: translateY(-20px);\n  }\n\n  60% {\n    transform: translateY(-10px);\n  }\n}\n\n.leaderboard h1 {\n  animation: bounce 2s infinite;\n}\n\n/* Leaderboard.css (añadir al final del archivo) */\n\n.trophy {\n  font-size: 1.5rem;\n  margin-right: 0.5rem;\n  flex: 1;\n  text-align: center;\n}\n\n.gold {\n  color: gold;\n}\n\n.silver {\n  color: silver;\n}\n\n.bronze {\n  color: #cd7f32;\n}\n\n\n@keyframes fireworks {\n  0% {\n    opacity: 1;\n    transform: scale(0.5);\n  }\n\n  100% {\n    opacity: 0;\n    transform: scale(1);\n  }\n}\n\n.firework {\n  position: absolute;\n  background: radial-gradient(circle, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 70%);\n  border-radius: 50%;\n  opacity: 0;\n  width: 10px;\n  height: 10px;\n  animation: fireworks 1s ease-out infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
